import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import {
  align_right,
  align_row,
  VM_ButtonGroup,
  VM_Colors,
  VM_ResponsiveBox
} from '../../Styles/VMStyles';
import TitleDesc from '../../Components/Custom/TitleDesc';
import {
  UPDATE_BELOW_DETAILS,
  VENUE_REGISTRATION
} from '../../Util/VMConstants';
import MUITextField from '../../Components/MUITextField';
import MUITextFieldSelect from '../../Components/MUITextFieldSelect';
import StyledInputField from "../../Components/Custom/StyledInputField";
import {
  getCountryCodeFromCountryID,
  getCurrencyFromCountryID,
  Venue_City,
  Venue_Country,
  Venue_State,
  Venue_Type,
  VM_transformCountryList,
  VM_transformStatesList,
  VM_venueTypes
} from '../../Helper/RegistrationHelper';
import { isEmpty, toTitleCaseInput } from '../../Util/UtilHelper';
import useCountryList from '../../Hooks/useCountryList';
import { toast } from 'react-toastify';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import MUITypography from '../../Components/MUITypography';
import AddPopUP from '../../Components/AddPopUP';
import ApiService, { postApi } from '../../Util/ApiService';
import {
  API_ADD_CITY,
  API_CITIES,
  API_STATES,
  API_UPDATE_VENUE_REGISTRATION
} from '../../Util/URLConstants';
import CloseIcon from '@mui/icons-material/Close';
import MuiTypographyMandatory from '../../Components/Custom/MuiTypographyMandatory';

function UpdateVenueRegistration({ venueState ,onClose,loadProfile}) {
  const [state, setState] = useState({
    venuename: '',
    venuetype: '',
    countryCode: '',
    venuemobileno: '',
    venueaddress: '',
    venuepincode: '',
    venuecountry: '',
    businesslabel: '',
    businessnumber: '',
    venueemail: '',
    venuewebsiteurl: '',
    countryID: '',
    stateID: '',
    cityID: '',
    currency: ''
  });

  const [warning, setWarning] = useState({
    venueTypeError: false,
    venueCountryError: false,
    venueStateError: false,
    venueCityError: false
  });

  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [newCity, setNewCity] = useState('');
  const [loading,setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const { country } = useCountryList();

  const fieldGridProps = {
    size: { xs: 12, sm: 6, md: 4 },
    sx: { minWidth: 0 },
  };

  const fieldSx = { width: "100%", minWidth: 0 };

  const fetchStates = async (countryID) => {
    if (!countryID) return;
    try {
      setStatesList([]);
      setLoading(true);
      const response = await ApiService.getApi(`${API_STATES}${countryID}`);
      setStatesList(response);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching states:', error);
      setLoading(false);
    }
  };

  const fetchCities = useCallback(async () => {
    try {
      setLoading(true)
      if (state.stateID) {
        const response = await ApiService.getApi(`${API_CITIES}${state.stateID}`);
        setCitiesList(response);
      }
      setLoading(false)
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  }, [state.stateID]);

  const handleAddCity = async () => {
    try {
      const obj = {
        cityName: newCity,
        stateID: state.stateID,
        countryID: state.countryID
      };
      setLoading(true)
      await postApi(API_ADD_CITY, obj);
      setLoading(false)
      fetchCities();
      toast.success("City added successfully");

    } catch (error) {
      toast.error("Failed to add city");
      console.error("Failed to add city:", error);
    }
  };

  useEffect(() => {
    fetchCities();
  }, [fetchCities]);

  useEffect(() => {
    console.log("venueState: ",venueState);
    if (venueState) {
      setState((prev) => ({
        ...prev,
        venuename: venueState.venue_name || '',
        venuetype: venueState.venue_type || '',
        countryCode: venueState.country_code || '',
        venuemobileno: venueState.venue_mobile_no || '',
        venueemail: venueState.venue_email || '',
        venueaddress: venueState.address || '',
        venuepincode: venueState.pincode || '',
        businesslabel: venueState.business_label || '',
        businessnumber: venueState.business_number || '',
        venuewebsiteurl: venueState.website_url || '',
        countryID: venueState.country || '',
        stateID: venueState.state || '',
        cityID: venueState.city ,
        currency: venueState.currency || '',
        venuecountry: venueState.country || '',
        venuestate: venueState.state || ''
      }));
      fetchStates(venueState.country);
    }
  }, [venueState]);

useEffect(() => {
  if (citiesList.length > 0 && state.cityID) {
    const matchedCity = citiesList.find((city) => String(city.id) === String(state.cityID));
    if (matchedCity) {
      setState((prev) => ({
        ...prev,
        cityID: matchedCity.id // reassign to ensure correct match
      }));
    }
  }
}, [citiesList, state.cityID]);


  const submitHandler = async () => {
    setLoading(true)
    const missingFields = {
      venueTypeError: isEmpty(state.venuetype),
      venueCountryError: isEmpty(state.countryID),
      venueStateError: isEmpty(state.stateID),
      venueCityError: isEmpty(state.cityID)
    };

    setWarning(missingFields);

    const hasErrors = Object.values(missingFields).some(Boolean);
    if (hasErrors) return;

    const payload = {
      venue_id : venueState.venue_id,   
      user_id: venueState.user_id,
      venue_name: state.venuename,
      venue_type: state.venuetype,
      country_code: state.countryCode,
      venue_mobile_no: state.venuemobileno,
      venue_email: state.venueemail,
      currency: state.currency,
      country: state.countryID,
      state: state.stateID,
      city: state.cityID,
      address: state.venueaddress,
      pincode: state.venuepincode,
      business_label: state.businesslabel,
      business_number: state.businessnumber,
      website_url: state.venuewebsiteurl
    };

    try {
      const resp = await postApi(API_UPDATE_VENUE_REGISTRATION, payload);
      setLoading(false)
      if (resp.status_code === 200) {
        toast.success(resp.message || "Venue updated successfully");
        onClose();
        loadProfile();
      } else {
        toast.error("Update failed");
      }
    } catch (error) {
      setLoading(false)
      toast.error("Server error during update");
      console.error("Update error:", error);
    }
  };

  return (
    <Box sx={VM_ResponsiveBox}>
      <Box sx={{ width: "100%", maxWidth: "100%" }}>
        <Box sx={align_row} >
          <Box sx={{width:'90%'}}>
                      <TitleDesc title={VENUE_REGISTRATION} subtitle={UPDATE_BELOW_DETAILS} />
          </Box>
          <Box sx={align_right}>
              <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

        </Box>

        <Grid container spacing={2} sx={{ mt: 2, width: "100%" }}>
          <Grid {...fieldGridProps}>
            <StyledInputField
              heading="Venue Name"
              name="venuename"
              placeholder="Enter Your Venue Name"
              value={state.venuename}
              onChange={(e) =>
                setState({ ...state, venuename: toTitleCaseInput(e.target.value) })
              }
              fullWidth
            />
          </Grid>

          <Grid {...fieldGridProps}>
            <Box sx={fieldSx}>
              <MuiTypographyMandatory label="Venue Type" required />
              <MUITextFieldSelect
                name={Venue_Type}
                id={Venue_Type}
                required
                value={state.venuetype}
                error={warning.venueTypeError}
                onChange={(e) =>
                  setState({ ...state, venuetype: e.target.value })
                }
                options={VM_venueTypes}
                fullWidth
                sx={fieldSx}
              />
            </Box>
          </Grid>

          <Grid {...fieldGridProps}>
            <StyledInputField
              heading={
                isEmpty(state.countryCode)
                  ? "Venue Mobile no"
                  : `Venue Mobile no (+${state.countryCode})`
              }
              name="venuemobileno"
              placeholder="Enter Mobile Number"
              value={state.venuemobileno}
              onChange={(e) => {
                let input = e.target.value.replace(/\D/g, "");
                input = input.slice(0, 10);
                setState({ ...state, venuemobileno: input });
              }}
              fullWidth
              inputProps={{ maxLength: 15, inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>

          <Grid {...fieldGridProps}>
            <Stack spacing={0.5} sx={fieldSx}>
              <MuiTypographyMandatory label="Country" required />
              <MUITextFieldSelect
                name={Venue_Country}
                id={Venue_Country}
                required
                value={state.venuecountry}
                options={VM_transformCountryList(country)}
                error={warning.venueCountryError}
                onChange={(e) => {
                  const CID = e.target.value;
                  setState({
                    ...state,
                    venuecountry: CID,
                    countryID: CID,
                    currency: getCurrencyFromCountryID(country, CID),
                    countryCode: getCountryCodeFromCountryID(country, CID),
                  });
                  fetchStates(CID);
                }}
                fullWidth
                sx={fieldSx}
              />
            </Stack>
          </Grid>

          <Grid {...fieldGridProps}>
            <Stack spacing={0.5} sx={fieldSx}>
              <MuiTypographyMandatory label="State" required />
              <MUITextFieldSelect
                name={Venue_State}
                id={Venue_State}
                required
                placeholder="Select Your State"
                value={state.stateID}
                options={VM_transformStatesList(statesList)}
                error={warning.venueStateError}
                onChange={(e) => {
                  const SID = e.target.value;
                  setState({ ...state, stateID: SID });
                }}
                fullWidth
                sx={fieldSx}
              />
            </Stack>
          </Grid>

          <Grid {...fieldGridProps}>
            <Stack spacing={0.5} sx={fieldSx}>
              <MuiTypographyMandatory label="City" required />
              <Autocomplete
                name={Venue_City}
                id={Venue_City}
                options={Array.isArray(citiesList) ? citiesList : []}
                getOptionLabel={(option) => option.city || ""}
                value={citiesList.find((city) => city.id === state.cityID) || null}
                onChange={(event, newValue) => {
                  setState({ ...state, cityID: newValue ? newValue.id : null });
                }}
                noOptionsText={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      px: 2,
                      py: 1,
                      fontFamily: "Lato",
                      fontSize: "0.95rem",
                    }}
                    onClick={() => {
                      if (isEmpty(state.stateID)) {
                        toast.error("Please select State");
                        return;
                      }
                      setOpenDialog(true);
                    }}
                  >
                    <AddLocationAltIcon fontSize="small" color="primary" />
                    <Typography
                      variant="body2"
                      sx={{
                        fontFamily: "Lato",
                        fontSize: "0.95rem",
                        color: "primary.main",
                        cursor: "pointer",
                        textDecoration: "underline",
                        "&:hover": {
                          color: "primary.dark",
                        },
                      }}
                      onClick={handleAddCity}
                    >
                      Click Here To Add Your City
                    </Typography>
                  </Box>
                }
                renderInput={(params) => (
                  <MUITextField
                    {...params}
                    placeholder="Select your city"
                    fullWidth
                    error={warning.venueCityError}
                    InputProps={{
                      ...params.InputProps,
                      sx: {
                        fontFamily: "Lato",
                        fontSize: "1rem",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontFamily: "Lato",
                        fontSize: "1rem",
                      },
                    }}
                  />
                )}
                sx={{
                  width: "100%",
                  minWidth: 0,
                  fontFamily: "Lato",
                  fontSize: "1rem",
                  "& .MuiAutocomplete-input": {
                    fontFamily: "Lato",
                    fontSize: "1.1rem",
                  },
                  "& .MuiAutocomplete-option": {
                    fontFamily: "Lato",
                    fontSize: "1.1rem",
                  },
                }}
              />
            </Stack>
          </Grid>

          <Grid {...fieldGridProps}>
            <StyledInputField
              heading="Venue Address (Optional)"
              placeholder="Venue Address "
              value={state.venueaddress}
              onChange={(e) => setState({ ...state, venueaddress: e.target.value })}
              fullWidth
            />
          </Grid>

          <Grid {...fieldGridProps}>
            <StyledInputField
              heading="Enter pincode"
              placeholder="Enter pincode"
              name="venuepincode"
              value={state.venuepincode}
              onChange={(e) => setState({ ...state, venuepincode: e.target.value })}
              fullWidth
              inputProps={{ maxLength: 6 }}
            />
          </Grid>

          <Grid {...fieldGridProps}>
            <StyledInputField
              heading="GSTIN/PAN/VAT/Business Label"
              placeholder="GSTIN/PAN/VAT/Business Label"
              name="businesslabel"
              value={state.businesslabel}
              onChange={(e) => setState({ ...state, businesslabel: e.target.value })}
              fullWidth
            />
          </Grid>

          <Grid {...fieldGridProps}>
            <StyledInputField
              heading="Venue Email"
              name="venueemail"
              placeholder="Your email address"
              type="email"
              value={state.venueemail}
              onChange={(e) => setState({ ...state, venueemail: e.target.value })}
              fullWidth
            />
          </Grid>

          <Grid {...fieldGridProps}>
            <StyledInputField
              heading="Website Url (Optional)"
              name="venuewebsiteurl"
              placeholder="Enter Website Url"
              value={state.venuewebsiteurl}
              onChange={(e) => setState({ ...state, venuewebsiteurl: e.target.value })}
              fullWidth
            />
          </Grid>
        </Grid>

        {/* Add City Popup */}
        {openDialog && (
          <AddPopUP
            isDisplay={openDialog}
            title={<MUITypography label="Add New City" />}
            renderBody={
              <TextField
                autoFocus
                margin="dense"
                label="City Name"
                fullWidth
                variant="outlined"
                value={newCity}
                onChange={(e) => setNewCity(e.target.value)}
              />
            }
            renderActionButton={
              <Box sx={{ paddingRight: 2, display: 'flex', justifyContent: 'center' }}>
                <Button onClick={() => setOpenDialog(false)} sx={{ mr: 2 }}>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    handleAddCity();
                    setOpenDialog(false);
                    setNewCity('');
                  }}
                  variant="contained"
                  disabled={!newCity.trim()}
                >
                  Add
                </Button>
              </Box>
            }
          />
        )}

        {/* Action Buttons */}
        <Box sx={VM_ButtonGroup}>
          <Button
            variant="contained"
            color="primary"
            onClick={submitHandler}
            sx={{
              fontWeight: 'bold',
              px: 4,
            }}
          >
            Update Venue
          </Button>
        </Box>
      </Box>
            {
              loading ? 
              <CircularProgress loading={loading} />
               : null 
            }
           
    </Box>
  );
}

export default UpdateVenueRegistration;

